(function() {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(
            event,
            params.bubbles,
            params.cancelable,
            params.detail
        );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

import store from "./state/store/";

class InteractivePanel {
    constructor(options) {
        this.dom = {
            el: options.panel
        };

        this.collection_bar = options.collection_bar;

        if (options.panel !== undefined && options.panel !== null) {
            this.bus = document.createElement("div");
            this.assign();
            this.events();
        }
    }

    assign() {
        this.dom.tabs = [...this.dom.el.querySelectorAll(".tab")];
        this.dom.letters = [...this.dom.el.querySelectorAll(".letter-tag")];
        this.dom.add_collection = document.querySelector("#add-to-collection");
        this.dom.add_cart = document.querySelector("#add-to-cart");

        // Assign lettes to tabs for later
        this.dom.tabs.map(tab => {
            let pid = tab.getAttribute("data-product-id");

            let ls = this.dom.letters.filter(letr => {
                if (letr.getAttribute("data-product-id") == pid) {
                    return letr;
                }
            });

            if (ls.length > 0) {
                tab.data = {
                    sku: ls[0].getAttribute("data-product-sku"),
                    id: pid,
                    alt: ls[0]
                };

                ls[0].data = {
                    sku: ls[0].getAttribute("data-product-sku"),
                    id: pid,
                    alt: tab
                };
            }
        });
    }

    _toggle_noswatches() {
        // let s = [...document.querySelectorAll(".selected")];
        let t = [...document.querySelectorAll(".tab.active")];

        if (t.length === 1) {
            this.dom.add_collection.classList.add("noswatches");
            this.dom.add_cart.classList.add("noswatches");
            this.dom.add_collection.innerHTML =
                "<i class='fas fa-shopping-cart'></i> No swatches selected <span class='feature-tooltip'>To add samples to the sample cart, you must first select them by clicking on the swatches below.</span>";
            this.dom.add_cart.innerHTML =
                "<svg class='collection-icon'><use xlink:href='#collection-icon'></svg> No swatches selected <span class='feature-tooltip'>To add samples to the collection, you must first select them by clicking on the swatches below.</span>";
        } else {
            this.dom.add_collection.classList.remove("noswatches");
            this.dom.add_cart.classList.remove("noswatches");
            this.dom.add_collection.innerHTML = `<i class="fas fa-spinner fa-spin"></i>
    		<i class="fas fa-check"></i>
    		<svg class="collection-icon"><use xlink:href="#collection-icon"></svg> Add<span class="success-only">ed</span> to collection`;
            this.dom.add_cart.innerHTML = `<i class="fas fa-spinner fa-spin"></i>
        	<i class="fas fa-check"></i>
        	<i class="fas fa-shopping-cart"></i> Add<span class="success-only">ed</span> to sample cart`;
        }
    }

    manage_hover(els) {
        els.map(el => {
            el.addEventListener(
                "mouseenter",
                () => {
                    if (!el.classList.contains("hover")) {
                        el.classList.add("hover");
                        el.data.alt.classList.add("hover");
                    }
                },
                false
            );

            el.addEventListener(
                "mouseleave",
                e => {
                    if (e.target === e.currentTarget) {
                        el.classList.remove("hover");
                        el.data.alt.classList.remove("hover");
                    }
                },
                false
            );
        });
    }

    manage_select(els, clickLabel = false) {
        els.map(el => {
            el.addEventListener(
                "click",
                () => {
                    
                    if (!el.classList.contains("active")) {
                        this.add(el, clickLabel);
                    } else {
                        this.remove(el, clickLabel);
                    }
                },
                false
            );
        });
    }

    selected() {
        let selected = this.dom.tabs.filter(t => {
            return t.classList.contains("active");
        });

        if (selected.length > 0) {
            return selected[0];
        }
    }

    events() {
        // Refactor to allow for list of lists DRY
        this.manage_hover(this.dom.letters);
        this.manage_hover(this.dom.tabs);

        this.manage_select(this.dom.letters, true);
        this.manage_select(this.dom.tabs, false);

        this.bus.addEventListener("remove", () => {
            this.collection_bar.close();
        });
    }

    add(el, clickLabel = false) {
        let data = el.data;
        let event = new CustomEvent("add");

        let json = JSON.stringify({
            sku: data.sku,
            quantity: 1,
            id: data.id
        });

        store.dispatch("staged_add", json);

        this._toggle_noswatches();

        if (clickLabel) {
            el.data.alt.querySelector("label").click();
        } else {
            el.classList.add("active");
            el.data.alt.classList.add("active");
        }

        this.collection_bar.open();

        window.stagedProducts.add(json);
        this.bus.dispatchEvent(event);
    }

    remove(el, clickLabel = false) {
        let data = el.data;
        let event = new CustomEvent("remove");

        let json = JSON.stringify({
            sku: data.sku,
            quantity: 1,
            id: data.id
        });

        this._toggle_noswatches();

        if (clickLabel) {
            el.data.alt.querySelector("label").click();
        } else {
            el.classList.remove("active");
            el.data.alt.classList.remove("active");
        }

        window.stagedProducts.delete(json);
        this.bus.dispatchEvent(event);

    }
}

export default InteractivePanel;
